module.exports = __webpack_public_path__ + "static/media/tangerina.fe1d1eee.png";